import { StoreCreator, StoreEnhancer, Reducer, Store } from "redux";

import { RootState } from "../../store/types";
import { actions as step1Actions, selectors as step1Selectors } from "../Step1";
import {
  actions as styleActs,
  selectors as styleSelectors,
} from "../WizardStyleChoice";
import {
  actions as layoutActs,
  selectors as layoutSelectors,
} from "../WizardLayoutChoice";
import {
  actions as colorActs,
  selectors as colorSelectors,
} from "../WizardColorChoice";
import { actions as step4Actions, selectors as step4Selectors } from "../Step4";
import { actions as step5Actions, selectors as step5Selectors } from "../Step5";

const storage = window.sessionStorage;

const restore = (store: Store<RootState>) => {
  const chosenProduct = storage.getItem("chosenProduct");
  const chosenStyle = storage.getItem("chosenStyle");
  const customStyle = storage.getItem("customStyle");
  const chosenColor = storage.getItem("chosenColor");
  const chosenLayout = storage.getItem("chosenLayout");
  const layouts = storage.getItem("layouts");
  const projectForm = storage.getItem("projectForm");
  const suppForm = storage.getItem("suppForm");

  try {
    if (chosenProduct) {
      store.dispatch(step1Actions.setChosenProduct(JSON.parse(chosenProduct)));
    }
    if (chosenStyle) {
      store.dispatch(styleActs.setStyleSelection(JSON.parse(chosenStyle)));
    }
    if (customStyle) {
      store.dispatch(styleActs.setDescVal(JSON.parse(customStyle)));
    }
    if (chosenColor) {
      store.dispatch(colorActs.setChosenColor(JSON.parse(chosenColor)));
    }
    if (chosenLayout) {
      store.dispatch(layoutActs.setChosenLayout(JSON.parse(chosenLayout)));
    }
    if (layouts) {
      store.dispatch(layoutActs.setLayouts(JSON.parse(layouts)));
    }
    if (projectForm) {
      store.dispatch(
        step4Actions.setProjectFormValues(JSON.parse(projectForm)),
      );
    }
    if (suppForm) {
      store.dispatch(step5Actions.setSuppFormValues(JSON.parse(suppForm)));
    }
  } catch (err) {
    // Parsing error encounted, probably something else unexpectedly in storage keys
    //   just ignore, but user will have to start-over
  }
};

const dump = (store: Store<RootState>) =>
  store.subscribe(() => {
    const state = store.getState();

    const chosenProduct = step1Selectors.chosenProduct(state);
    const chosenStyle = styleSelectors.selectedStyle(state);
    const customStyle = styleSelectors.descriptionValue(state);
    const chosenColor = colorSelectors.chosenColor(state);
    const chosenLayout = layoutSelectors.chosenLayout(state);
    const layouts = layoutSelectors.layouts(state);
    const projectForm = step4Selectors.savedFormValues(state);
    const suppForm = step5Selectors.savedFormValues(state);

    try {
      if (chosenProduct) {
        storage.setItem("chosenProduct", JSON.stringify(chosenProduct));
      }
      if (chosenStyle) {
        storage.setItem("chosenStyle", JSON.stringify(chosenStyle));
      }
      if (customStyle) {
        storage.setItem("customStyle", JSON.stringify(customStyle));
      }
      if (chosenColor) {
        storage.setItem("chosenColor", JSON.stringify(chosenColor));
      }
      if (chosenLayout) {
        storage.setItem("chosenLayout", JSON.stringify(chosenLayout));
      }
      if (layouts) {
        storage.setItem("layouts", JSON.stringify(layouts));
      }
      if (projectForm) {
        storage.setItem("projectForm", JSON.stringify(projectForm));
      }
      if (suppForm) {
        storage.setItem("suppForm", JSON.stringify(suppForm));
      }
    } catch (error) {
      // Cannot access Storage; problem with private browsing in Safari
    }
  });

// Keeps wizard-related state in-sync with session storage
const wizardEnhancer = (storeCreator: StoreCreator) => (
  reducer: Reducer<RootState>,
  initState: RootState,
  enhancer: StoreEnhancer<RootState>,
) => {
  const store = storeCreator(reducer, initState, enhancer);

  restore(store);
  dump(store);

  return store;
};

export default wizardEnhancer;



// WEBPACK FOOTER //
// ./src/routes/Wizard/enhancer.ts